export default [
  {
    title: 'Dark',
    uri: 'mapbox://styles/mapbox/dark-v9',
  },
  {
    title: 'Light',
    uri: 'mapbox://styles/mapbox/light-v9',
  },
  {
    title: 'Streets',
    uri: 'mapbox://styles/mapbox/streets-v11',
  },
  {
    title: 'Satellite',
    uri: 'mapbox://styles/mapbox/satellite-v9',
  },
]
